module.exports = __webpack_public_path__ + "static/img/img1.8f5e0c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/images/img1.png
// module id = f+Lz
// module chunks = 1